import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=a2e819c6&scoped=true"
import script from "./CommentList.vue?vue&type=script&lang=js"
export * from "./CommentList.vue?vue&type=script&lang=js"
import style0 from "./CommentList.vue?vue&type=style&index=0&id=a2e819c6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e819c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2e819c6')) {
      api.createRecord('a2e819c6', component.options)
    } else {
      api.reload('a2e819c6', component.options)
    }
    module.hot.accept("./CommentList.vue?vue&type=template&id=a2e819c6&scoped=true", function () {
      api.rerender('a2e819c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CommentList.vue"
export default component.exports